module.exports = __webpack_public_path__ + "img/participants.dd2a45a6.svg";